module.exports = __webpack_public_path__ + "img/biao3.1a72a658.png";